import { render, staticRenderFns } from "./MessengerToken.vue?vue&type=template&id=046896ce&"
import script from "./MessengerToken.vue?vue&type=script&lang=js&"
export * from "./MessengerToken.vue?vue&type=script&lang=js&"
import style0 from "./MessengerToken.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports